import React from 'react';
import { SxProps, TextField, Theme } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { formatPriceDifferenceValueInNumberInput } from '@/core/helpers/form';

interface PriceDifferenceInputProps {
  label: string;
  controllerName: string;
  fieldOnBlur?: () => void;
  sx?: SxProps<Theme>;
}

export const FormPriceDifferenceInputController = ({
  label,
  controllerName,
  fieldOnBlur,
  sx,
}: PriceDifferenceInputProps) => {
  const { control } = useFormContext();
  const handleChange = (value: string, onChange: (value: number | undefined) => void) => {
    const cleanedValue = formatPriceDifferenceValueInNumberInput(value);
    onChange(cleanedValue as unknown as number);
  };
  return (
    <Controller
      name={controllerName}
      control={control}
      render={({ field: { value, onChange, onBlur, ...field } }) => {
        return (
          <TextField
            {...field}
            label={label}
            type="string"
            value={value ?? ''}
            onChange={(event) => handleChange(event.target.value, onChange)}
            onBlur={() => {
              onBlur();
              fieldOnBlur?.();
            }}
            sx={sx}
          />
        );
      }}
    />
  );
};
